// Inspired by https://github.com/Vagr9K/gatsby-advanced-starter

import React, { Component } from 'react';
import Helmet from 'react-helmet';

const config = {
  siteTitle: 'Fabian Schultz',
  author: 'Fabian Schultz',
  siteDescription: `Hello, I'm Fabian Schultz — a product designer and developer based in Potsdam, Germany.`,
  siteUrl: 'https://blog.fabianschultz.com',
  userTwitter: 'fschultz_',
};

class SEO extends Component {
  render() {
    const { postNode, postPath, postSEO } = this.props;
    const { siteTitle, siteUrl, siteDescription, userTwitter, author } = config;
    let title;
    let description;
    let postURL;

    if (postSEO) {
      const postMeta = postNode;
      title = `${postMeta.frontmatter.title} | ${siteTitle}`;
      description = postMeta.excerpt
        ? postMeta.excerpt
        : postNode.frontmatter.title;
      postURL = siteUrl + '/' + postPath;
    } else {
      title = siteTitle;
      description = siteDescription;
    }

    const schemaOrgJSONLD = [
      {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        url: siteUrl,
        name: title,
        alternateName: '',
      },
    ];
    if (postSEO) {
      schemaOrgJSONLD.push({
        '@context': 'http://schema.org',
        '@type': 'BlogPosting',
        url: postURL,
        name: title,
        author: {
          '@type': 'Person',
          name: author,
        },
        publisher: {
          '@type': 'Organization',
          name: siteTitle,
          logo: {
            '@type': 'ImageObject',
            url: 'https://fabianschultz.com/publisher.jpg',
          },
        },
        datePublished: postNode.date,
        alternateName: '',
        headline: postNode.frontmatter.title,
        description,
      });
    }

    return (
      <Helmet>
        {/* General tags */}
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={postSEO ? postURL : siteUrl} />

        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>

        {/* OpenGraph tags */}
        <meta property="og:url" content={postSEO ? postURL : siteUrl} />
        {postSEO ? <meta property="og:type" content="article" /> : null}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />

        {/* Twitter Card tags */}
        <meta name="twitter:creator" content={userTwitter ? userTwitter : ''} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
    );
  }
}

export default SEO;



// WEBPACK FOOTER //
// ./src/components/SEO.js